import 'flag-icons/css/flag-icons.min.css';

interface FlagIconProps {
  code: string | null | undefined;
  size?: number;
  className?: string;
}

export default function FlagIcon({ code, size = 20, className = '' }: FlagIconProps) {
  if (!code || !/^[A-Za-z]{2}$/.test(code)) {
    return <span style={{ fontSize: size }}>🌍</span>;
  }

  return (
    <span
      className={`fi fi-${code.toLowerCase()} fis ${className}`}
      style={{ fontSize: size, lineHeight: 1 }}
    />
  );
}
